import { Icon, Tooltip } from "antd";
import React, { Component, useState } from "react";
import { withTranslation } from "react-i18next";
import DEFINE, {
  DETAIL_ACTIONS,
  CAMPAIGN as CAMPAIGN_ENUM,
  PATHS,
  MARKUP,
  FEATURE_FLAGS,
  CAMPAIGN
} from "../../../../../constants/Define";
import {
  capitalizeFirstLetter,
  formatValidation,
  getPermissionActions,
  multipleValidate
} from "../../../../../helpers/functions";
import { FormWrapperItem } from "../../../common/component/Index";
import {
  FormActionComponent,
  HeaderListComponent,
  LoadingComponent,
  PageListComponent
} from "../../../common/component/Index";
import TranslateButton from "../../../common/component/TranslateButton";
import Campaign from "../../../../../models/Campaign";
import { cloneDeep, find, isEqual, toArray } from "lodash";
import "./CampaignDetail.less";
import CampaignInfoSection from "./components/CampaignInfoSection";
import UseObjectSection from "./components/UseObjectSection";
import UseHotelSection from "./components/UseHotelSection";
import UseProductsSection from "./components/UseProductsSection";
import SearchInfoConfigSection from "./components/SearchInfoConfigSection";
import SpecialEventSection from "./components/SpecialEventSection";
import FormatCodeSection from "./components/FormatCodeSection";
import LoyaltyCodeSection from "./components/LoyaltyCodeSection";
import ConfigPromotionMarkupSection from "./components/ConfigPromotionMarkupSection";
import PaymentCampaignTitleSection from "./components/PaymentCampaignTitleSection";
import CampaignPromotionInfoSection from "./components/CampaignPromotionInfoSection";
import { getCreateType, getPromotionCampaignFromCampaign, isPositiveIntegerOrEmpty, isTotalBudgetValid } from "./utils";
import * as CampaignService from '../../../../../services/campaignService';
import UseSupplierSection from "./components/UseSupplierSection";
import AutoTranslate from "containers/backend/common/component/AutoTranslate/AutoTranslate";

const defaultState = {
  campaign: new Campaign(),
  action: DETAIL_ACTIONS.CREATE,
  validation: {},
  createType: null,
  isGetItem: false,
  isSubmit: false
};

let permissionActions = [];

export class CampaignDetail extends Component {
  state = {
    ...defaultState,
    campaign: this.props.campaignState.detail.campaign || defaultState.campaign,
    promotionCampaign: {},
    isLoyaltyPromotion: false,
    isLoadingLoyaltyPromoCamp: false
  };

  componentDidMount() {
    permissionActions = getPermissionActions(
      DEFINE.GENERAL.ROUTE_NAME.CAMPAIGN
    );
    this.initDetail();
  }

  componentWillUnmount() {
    this.props.setCampaignDetail(new Campaign());
  }

  componentDidUpdate() {}

  setCampaign = (campaign, callback) => {
    const nextCampaign = campaign instanceof Campaign
      ? campaign
      : new Campaign(campaign);
    this.setState({ campaign: nextCampaign }, callback);
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.campaignState.detail.campaign && !isEqual(nextProps.campaignState.detail.campaign, this.props.campaignState.detail.campaign)) {
      const campaign = cloneDeep(nextProps.campaignState.detail.campaign);
      const productType = campaign && campaign.productType && campaign.productType.length > 0 ?
          campaign.productType[0] : '';
      let createType = undefined;
      if (campaign.isCampaignPoint) {
        createType = CAMPAIGN_ENUM.CREATE_TYPE['DIEM'];
      } else if(toArray(MARKUP.CAMPAIGN_TYPE).filter(type => type.id === productType).length > 0){
          createType = CAMPAIGN_ENUM.CREATE_TYPE['MARKUP'];
          campaign.discountMode = 'ALL';
      } else {
          createType = find(toArray(CAMPAIGN_ENUM.CREATE_TYPE), type => type.id === productType.toLowerCase());
      }
      const nextPromotionCampaign = getPromotionCampaignFromCampaign(nextProps.campaignState.detail.campaign);
      const currentPromotionCampaign = getPromotionCampaignFromCampaign(this.props.campaignState.detail.campaign);

      if (!isEqual(nextProps.campaignState.detail.campaign, this.props.campaignState.detail.campaign) || !isEqual(nextPromotionCampaign, currentPromotionCampaign)
      ) {
        const { promotionCampaign, isLoyaltyPromotion } = nextPromotionCampaign;
        this.setState({
          campaign: campaign,
          action: campaign.id ? "UPDATE" : this.state.action,
          createType: createType,
          promotionCampaign,
          isLoyaltyPromotion
        });
      } else {
        this.setState({ campaign: campaign, action: campaign.id ? 'UPDATE' : this.state.action, createType: createType });
      }
    }
  }

  initDetail() {
    const { match } = this.props;
    if (Object.keys(match.params).length > 0) {
      if (!!match.params.id) {
        this.setState({
          action: DETAIL_ACTIONS.UPDATE,
          campaign: cloneDeep(defaultState.campaign)
        });
        this.props.getCampaignDetail(match.params.id);
      } else if (!!match.params.type) {
        const createType = find(
          toArray(CAMPAIGN_ENUM.CREATE_TYPE),
          type => type.id === match.params.type
        );
        const nextProductType =
          createType.id === CAMPAIGN_ENUM.CREATE_TYPE.HOTEL.id
            ? [`${CAMPAIGN_ENUM.CREATE_TYPE.HOTEL.label}`]
            : createType.id === CAMPAIGN_ENUM.CREATE_TYPE.FNB.id
              ? [CAMPAIGN_ENUM.PRODUCT_TYPE.FNB.value]
              : [];
        let nextCampaign = new Campaign({ productType: nextProductType });
        nextCampaign.discountMode =
          createType === CAMPAIGN_ENUM.CREATE_TYPE.MARKUP
            ? "ALL"
            : defaultState.campaign.discountMode;

        this.setState(
          {
            action: DETAIL_ACTIONS.CREATE,
            campaign: nextCampaign,
            createType
          },
          () => {
          }
        );
      }
    }
    // this.props.getCountries();
    this.props.getChannels();
    this.props.getPromotionBanks();
  }

  getTitleHeader() {
    const { t } = this.props;
    const { action, createType } = this.state;
    return (
      (action === DETAIL_ACTIONS.CREATE
        ? capitalizeFirstLetter(
            `${t("action.create")} ${t("item.campaign.title")}`.toLowerCase()
          )
        : capitalizeFirstLetter(
            `${t("action.update")} ${t("item.campaign.title")}`.toLowerCase()
          )) + (createType?.label ? ` ${createType?.label}` : "")
    );
  }

  renderInfoTooltip(title, content, className) {
    return (
      <Tooltip key={Math.random()} title={title}>
        {content}
        <Icon className={className} type="info-circle" />
      </Tooltip>
    );
  }

  handleSwitchChange = () => {
    this.setState(
      { isLoyaltyPromotion: !this.state.isLoyaltyPromotion },
      () => {
        if (this.state.isLoyaltyPromotion) {
          //TODO: call api
        }
      }
    );
  };

  render() {
    const {
      t,
      match,
      campaignState,
      autoTranslateState,
      tagGroupDetailState,
      hotelState,
      rateState,
      supplierState,
      onUploadFile,
      file,
      tagGroupState,
      homestayState
    } = this.props;
    const {
      action,
      campaign,
      validation,
      isSubmit,
      isGetItem,
      createType,
      isLoyaltyPromotion,
      isLoadingLoyaltyPromoCamp,
      promotionCampaign
    } = this.state;
    const { channels, banks } = campaignState;
    const loading = campaignState.isFetching || autoTranslateState.campaign.isTranslating;
    const ratePlansGroup = {
      hotelId: rateState.dataList[0]?.hotelId,
      ratePlans: rateState.dataList.filter(item => item.isActive && item.status)
    };
    const { tagsByGroup } = tagGroupState;

    const displayTargets = [];

    const isMarkupHotel = (campaign?.productType || []).includes(MARKUP.CAMPAIGN_TYPE.MARKUP_HOTEL.value);
    
    return (
      <LoadingComponent spinning={loading}>
        <PageListComponent className="campaign-detail-page">
          <HeaderListComponent
            path={match.path}
            groupPath={"campaign"}
            titleHeader={this.getTitleHeader()}
            componentRight={
              FEATURE_FLAGS.TRANSLATE_ENABLE && (
                <TranslateButton
                  languages={campaign.translations}
                  current={campaign.languageCode}
                  validation={validation.languageCode}
                  onChange={this.onShowTranslate}
                  onClear={this.onExitTranslate}
                  defaultSelecting={action === DETAIL_ACTIONS.CREATE}
                  onSelectDefault={language =>
                    this.onChange("languageCode", language.code)
                  }
                  onRemove={this.onRemoveTranslate}
                />
              )
            }
          />
          <FormActionComponent
            onSubmit={this.onSubmit}
            isSubmit={isSubmit}
            action={action}
            isGetItem={isGetItem}
            onClickBack={this.onClickBack}
            submitButtonRight={true}
            disableButtonSubmit={this.isDisableSubmit()}
            backButtonText={
              action === DETAIL_ACTIONS.TRANSLATE
                ? t(`action.cancel`)
                : t(`action.back`)
            }
            titleButtonSubmit={
              action === DETAIL_ACTIONS.TRANSLATE ? t(`action.save`) : undefined
            }
          >
            <FormWrapperItem>
              <CampaignInfoSection
                createType={createType}
                campaign={campaign}
                validation={validation}
                action={action}
                campaignState={campaignState}
                onChange={this.onChange}
                renderInfoTooltip={this.renderInfoTooltip}
                getTagsByGroup={this.props.getTagsByGroup}
                tagsByGroup={tagsByGroup}
                setCampaign={this.setCampaign}
              />
              {/* Đối tượng áp dung */}
              <UseObjectSection
                campaign={campaign}
                validation={validation}
                action={action}
                onChange={this.onChange}
                renderInfoTooltip={this.renderInfoTooltip}
                setCampaign={this.setCampaign}
                createType={createType}
              />
              { createType !== CAMPAIGN_ENUM.CREATE_TYPE.DIEM &&
                createType !== CAMPAIGN_ENUM.CREATE_TYPE.MARKUP &&
                (createType !== CAMPAIGN_ENUM.CREATE_TYPE.HOTEL
                  ? (
                  <UseProductsSection
                    campaign={campaign}
                    validation={validation}
                    action={action}
                    tagGroupDetailState={tagGroupDetailState}
                    supplierState={supplierState}
                    onChange={this.onChange}
                    renderInfoTooltip={this.renderInfoTooltip}
                    getAllSku={this.props.getAllSku}
                    getSupplierAll={this.props.getSupplierAll}
                    setCampaign={this.setCampaign}
                    onChangeMaxMin={this.onChangeMaxMin}
                  />
                ) : <UseHotelSection
                  campaign={campaign}
                  hotelState={hotelState}
                  homestayState={homestayState}
                  action={action}
                  setCampaign={this.setCampaign}
                  getAllHotel={this.props.getAllHotel}
                  getAllHomestay={this.props.getAllHomestay}
                  getListRates={this.props.getListRates}
                  ratePlansGroup={ratePlansGroup}
                />)
              }
              {createType === CAMPAIGN_ENUM.CREATE_TYPE.HOTEL && (
                <SearchInfoConfigSection
                  campaign={campaign}
                  action={action}
                  onChangeMaxMin={this.onChangeMaxMin}
                />
              )}
              {createType === CAMPAIGN_ENUM.CREATE_TYPE.HOTEL && (
                <SpecialEventSection
                  campaign={campaign}
                  action={action}
                  onChange={this.onChange}
                  setCampaign={this.setCampaign}
                />
              )}
              {createType !== CAMPAIGN_ENUM.CREATE_TYPE.DIEM &&
                <FormatCodeSection
                  createType={createType}
                  campaign={campaign}
                  validation={validation}
                  action={action}
                  onChange={this.onChange}
                  renderInfoTooltip={this.renderInfoTooltip}
                />
              }
              {createType !== CAMPAIGN_ENUM.CREATE_TYPE.DIEM &&
                createType !== CAMPAIGN_ENUM.CREATE_TYPE.HOTEL &&
                (createType !== CAMPAIGN_ENUM.CREATE_TYPE.MARKUP || isMarkupHotel) && (
                  <LoyaltyCodeSection
                    campaign={campaign}
                    action={action}
                    onChange={this.onChange}
                  />
                )
              }
              {createType === CAMPAIGN_ENUM.CREATE_TYPE.MARKUP && (
                <ConfigPromotionMarkupSection
                  campaign={campaign}
                  validation={validation}
                  channels={channels}
                  getMarkupPromotionConfig={this.props.getMarkupPromotionConfig}
                  getMarkupPromotionFly={this.props.getMarkupPromotionFly}
                  getMarkupBundleMinValue={this.props.getMarkupBundleMinValue}
                  campaignState={this.props.campaignState}
                  onChangeCampaignMarkup={this.onChangeCampaignMarkup}
                />
              )}
              { createType !== CAMPAIGN_ENUM.CREATE_TYPE.DIEM &&
                createType !== CAMPAIGN_ENUM.CREATE_TYPE.MARKUP && (
                  <PaymentCampaignTitleSection
                    campaign={campaign}
                    createType={createType}
                    validation={validation}
                    action={action}
                    banks={banks}
                    onChange={this.onChange}
                    onUploadFile={onUploadFile}
                    supplierState={supplierState}
                    setCampaign={this.setCampaign}
                    getSupplierAll={this.props.getSupplierAll}
                    getPromotionBanks={this.props.getPromotionBanks}
                  />
                )}
              {createType !== CAMPAIGN_ENUM.CREATE_TYPE.DIEM &&
                <CampaignPromotionInfoSection
                  action={action}
                  file={file}
                  campaign={campaign}
                  onUploadFile={onUploadFile}
                  promotionCampaign={promotionCampaign}
                  displayTargets={displayTargets}
                  validation={validation}
                  isLoyaltyPromotion={isLoyaltyPromotion}
                  isLoadingLoyaltyPromoCamp={isLoadingLoyaltyPromoCamp}
                  handleSwitchChange={this.handleSwitchChange}
                  onChange={this.onPromotionChange}
                />
              }
              {createType === CAMPAIGN_ENUM.CREATE_TYPE.DIEM && 
                <UseSupplierSection
                  campaign={campaign}
                  validation={validation}
                  supplierState={supplierState}
                  action={action}
                  setCampaign={this.setCampaign}
                  getSupplierAll={this.props.getSupplierAll}
                  getListRates={this.props.getListRates}
                />
              }
              {(action === DETAIL_ACTIONS.UPDATE) && (
                <AutoTranslate
                  className="wrapper-full campaign"
                  languageCode={campaign?.languageCode || 'vi-VN'}
                  onChange={this.onChange}
                  targetLanguage={campaign?.targetLanguage}
                />
              )}
            </FormWrapperItem>
          </FormActionComponent>
        </PageListComponent>
      </LoadingComponent>
    );
  }

  getExPromoTranslationParams = () => {
    const { promotionCampaign } = this.state || {};
    const promotionExtended = {
      Name: promotionCampaign?.pcDisplayName ?? "",
      ShortDescription: promotionCampaign?.pcDescription ?? "",
      DetailDescription: promotionCampaign?.pcDetail ?? "",
      AvatarUrl: promotionCampaign?.pcAvatar ?? "",
      ThumbnailUrl: promotionCampaign?.pcCover ?? "",
      LabelWording: promotionCampaign?.pcLableWording ?? "",
      CTAName: promotionCampaign?.pcCtaName ?? ""
    };
    return promotionExtended;
  };

  onSaveTranslate = () => {
    const campaign = this.state.campaign;
    const translateFunction = campaign.translate.id
      ? this.props.updateCampaignTranslate
      : this.props.createCampaignTranslate;
    const promotionExtended = this.getExPromoTranslationParams();
    const nextCampaign = new Campaign(campaign);
    const campaignTranslate = nextCampaign.export(true).translate();
    const params = campaign.translate.id
      ? { ...campaignTranslate, id: campaign.translate.id }
      : campaignTranslate;
    translateFunction(
      params,
      promotionExtended,
      campaign.languageCode,
      campaign.translate.languageName
    );
    this.onExitTranslate();
  };

  onShowTranslate = language => {
    const { campaign } = this.state;
    campaign.setTranslate(language.code);
    campaign.setData(undefined, true);
    const { promotionCampaign } = getPromotionCampaignFromCampaign(campaign);
    this.setState({
      campaign,
      action: DETAIL_ACTIONS.TRANSLATE,
      promotionCampaign
    });
  };

  onExitTranslate = () => {
    const campaign = this.state.campaign;
    const action = DETAIL_ACTIONS[campaign.id ? "UPDATE" : "CREATE"];
    campaign.setTranslate(undefined, true);
    campaign.setData();
    const { promotionCampaign } = getPromotionCampaignFromCampaign(campaign);
    this.setState({ campaign, action, promotionCampaign });
  };

  getPromotionCampaignData = () => {
    const { promotionCampaign, isLoyaltyPromotion } = this.state;
    if (!promotionCampaign || Object.keys(promotionCampaign).length === 0)
      return null;
    const PromotionExtended = {
      Name: promotionCampaign.pcDisplayName,
      ShortDescription: promotionCampaign.pcDescription,
      DetailDescription: promotionCampaign.pcDetail,
      AvatarUrl: promotionCampaign.pcAvatar,
      ThumbnailUrl: promotionCampaign.pcCover,
      LabelWording: promotionCampaign.pcLableWording,
      CTAName: promotionCampaign.pcCtaName
    };
    const {
      pcDisplayTarget: ExPromotionMemberShipTypes,
      pcEmailSuffix: ExEmailSuffix,
      pcEmails: ExPromotionEmails
    } = promotionCampaign;
    let ExObjectType = CAMPAIGN.OBJECT_TYPE_DATA_EMAIL.EMAIL_SUFFIX.id;
    if (ExPromotionEmails) {
      ExObjectType = CAMPAIGN.OBJECT_TYPE_DATA_EMAIL.SPECIFIC.id;
    }
    const IsExtendPromotion = !isLoyaltyPromotion;
    return {
      IsExtendPromotion,
      PromotionExtended,
      ExPromotionMemberShipTypes,
      ExEmailSuffix,
      ExPromotionEmails,
      ExObjectType
    };
  };

  onSubmit = e => {
    e.preventDefault();
    const { campaign, action } = this.state;
    const createType = getCreateType(campaign)
    if (this.validate()) {
      const promotionCampaign = this.getPromotionCampaignData();

      let campaignData = {
        ...campaign,
        hotel: {
          ...campaign.hotel,
          minRoomNumber: parseInt(campaign.minRoomNumber) || 0,
          maxRoomNumber: parseInt(campaign.maxRoomNumber) || 0,
          minLenghOfStay: parseInt(campaign.minLenghOfStay) || 0,
          maxLenghOfStay: parseInt(campaign.maxLenghOfStay) || 0
        },
        maxCodeCount:
          campaign.codeType === CAMPAIGN_ENUM.CODE_TYPE.STANDARD.id
            ? 0
            : campaign.maxCodeCount,
      };
      if (
        createType?.key === "hotel" &&
        (!campaignData.productType || campaignData.productType.length === 0)
      ) {
        campaignData.productType = [`${CAMPAIGN_ENUM.CREATE_TYPE.HOTEL.label}`];
      }
      if (promotionCampaign && Object.keys(promotionCampaign).length) {
        campaignData = { ...campaignData, ...promotionCampaign };
      }
      
      if (this.state.createType === CAMPAIGN_ENUM.CREATE_TYPE.DIEM){
        campaignData = {
          ...campaign,
          isCampaignPoint: true,
          promotionType: "GENERAL",
        };
      }

      if (action === DETAIL_ACTIONS.TRANSLATE) {
        this.onSaveTranslate();
      } else if (action === DETAIL_ACTIONS.CREATE) {
        this.props.createCampaign(campaignData);
      } else {
        this.props.updateCampaign({
          ...campaignData,
          targetLanguage: campaign.targetLanguage,
        });
      }
    }
  };

  onClickBack = () => {
    if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
      this.onExitTranslate();
    } else {
      this.props.history.push(PATHS.CAMPAIGN.LIST.path);
    }
  };

  onChange = (fieldName, value) => {
    if (fieldName === "codeCharCount" && value) {
      const intValue = parseInt(value);
      value =
        intValue > 10
          ? 10
          : intValue > 0 && intValue >= 1 && intValue <= 3
          ? 0
          : value;
    }
    const campaign = this.state.campaign;
    const validation = this.state.validation;
    campaign[fieldName] = value;
    if (
      fieldName === "codeType" &&
      value === CAMPAIGN_ENUM.CODE_TYPE.CUSTOMIZE.id
    ) {
      campaign.codePrefix = "";
      campaign.codeCharCount = 0;
      delete validation[`codePrefix`];
    }
    if (
      fieldName === "objectType" &&
      value === CAMPAIGN_ENUM.OBJECT_TYPE.ALL.id
    ) {
      delete validation[`objectType`];
    }
    if (fieldName === "propertyIds") {
      campaign.outletIds = [];
      campaign.menuIds = [];
      campaign.menuItemIds = [];
    }

    const createType = getCreateType(this.state.campaign);
    let isLoyaltyPromotion = this.state.isLoyaltyPromotion;
    if (
      createType &&
      createType.key === "sku" &&
      fieldName === "isLoyaltyVoucher"
    ) {
      if (!value && isLoyaltyPromotion) {
        isLoyaltyPromotion = false;
      }
    }
    if (createType && createType.key === "hotel" && fieldName === "codeType") {
      const { isLoyaltyBenefit, isLoyaltyVoucher } = campaign;
      if (!isLoyaltyBenefit && !isLoyaltyVoucher) {
        isLoyaltyPromotion = false;
      }
      // if (isLoyaltyBenefit) {
      //   isLoyaltyPromotion = false;
      // }
    }
    this.setState({ campaign, validation, isLoyaltyPromotion });
  };

  onPromotionChange = (fieldName, value, callback) => {
    const nextPromotionCampaign = { ...this.state.promotionCampaign };
    const nextValidation = { ...this.state.validation };
    nextPromotionCampaign[fieldName] = value;
    this.setState(
      { promotionCampaign: nextPromotionCampaign, validation: nextValidation },
      callback
    );
  };

  onChangeCampaignMarkup = (fieldName, value) => {
    const campaign = this.state.campaign;
    campaign.promotionMarkup[fieldName] = value;
    this.setState({ campaign });
  };

  onChangeMaxMin = (fieldName, value, compareFieldName, isMinInput = true) => {
    const campaign = this.state.campaign;
    const intCompareFieldName = parseInt(campaign[compareFieldName]);
    const intValue = parseInt(value);
    value =
      intCompareFieldName > 0 &&
      ((isMinInput && intValue > intCompareFieldName) ||
        (!isMinInput && intValue < intCompareFieldName))
        ? intCompareFieldName
        : value;
    campaign[fieldName] = value;
    this.setState({ campaign });
  };

  validatePaymentCampaign = campaign => {
    if (!campaign.isPaymentCampaign) {
      return {};
    }

    const { t } = this.props;
    const paymentCampaign = campaign.paymentCampaign;
    const result = {};
    const setError = (field, code) => {
      result[field] = {
        classError: "hms-error-form",
        messageError: t(`validation.statusCode.code.${code}`)
      };
    };

    if (campaign.codeType !== CAMPAIGN_ENUM.CODE_TYPE.CUSTOMIZE.id) {
      setError("codePrefix", "PAYMENT_MUST_CHOOSE_CUSTOMIZE_TYPE");
    }
    if (Number(campaign.maxCodeCount) !== 1) {
      setError("maxCodeCount", "MUST_ONE_CODE_ONLY");
    }
    if (campaign.promotionType !== CAMPAIGN_ENUM.PROMOTION_TYPE.GENERAL.id) {
      setError("promotionType", "PROMOTION_TYPE_INVALID");
    }

    const createType = getCreateType(campaign);
    if (createType !== CAMPAIGN_ENUM.CREATE_TYPE.HOTEL) {
      if (campaign.discountMode !== "ALL") {
        setError("discountMode", "DISCOUNT_MODE_INVALID");
      } else if (campaign.discountType !== CAMPAIGN_ENUM.DISCOUNT_TYPE.AMOUNT.id) {
        setError("discountType", "DISCOUNT_TYPE_INVALID");
      }
      if (Number(campaign.discountValue) !== 0) {
        setError("discountValue", "DISCOUNT_VALUE_INVALID");
      }
    }

    const bankContributionPercent = Number(paymentCampaign.bankContributionPercent);
    if (
      paymentCampaign.bankContributionPercent === null ||
      paymentCampaign.bankContributionPercent === "" ||
      bankContributionPercent < 0 ||
      bankContributionPercent > 100
    ) {
      setError("bankContributionPercent", "PROMOTION_BANK_CONTRIBUTION_PERCENT_INVALID");
    }

    if (
      !toArray(CAMPAIGN_ENUM.CONTRIBUTION_TYPE)
        .some(type => type.id === paymentCampaign.contributionType)
    ) {
      setError("contributionType", "PROMOTION_BANK_CONTRIBUTION_TYPE_REQUIRED");
    }

    if (!isTotalBudgetValid(paymentCampaign.totalBudget, paymentCampaign.budgetUsed)) {
      setError("totalBudget", "PROMOTION_BANK_BUDGET_LESS_THAN_USED");
    }

    if (paymentCampaign.bankType !== CAMPAIGN_ENUM.PAYMENT_BANK_TYPE.VPT.id) {
      return result;
    }

    if (!paymentCampaign.applyForPaymentMethods || !paymentCampaign.applyForPaymentMethods.length) {
      setError("applyForPaymentMethods", "PROMOTION_BANK_PAYMENT_METHOD_REQUIRED");
    }

    const discountValue = Number(paymentCampaign.bankDiscountValue);
    if (
      discountValue <= 0 ||
      (paymentCampaign.bankDiscountType === CAMPAIGN_ENUM.BANK_DISCOUNT_TYPE.PERCENT.id && discountValue > 100)
    ) {
      setError("bankDiscountValue", "PROMOTION_BANK_DISCOUNT_VALUE_INVALID");
    }

    if (
      paymentCampaign.bankDiscountType === CAMPAIGN_ENUM.BANK_DISCOUNT_TYPE.PERCENT.id &&
      Number(paymentCampaign.bankMaxDiscountValue) <= 0
    ) {
      setError("bankMaxDiscountValue", "PROMOTION_BANK_MAX_DISCOUNT_INVALID");
    }

    if (Number(paymentCampaign.minOrderValue) < 0) {
      setError("minOrderValue", "PROMOTION_BANK_MIN_ORDER_VALUE_INVALID");
    }

    return result;
  };

  validate() {
    const { t } = this.props;
    const { campaign, promotionCampaign, isLoyaltyPromotion } =
      this.state;
    const createType = getCreateType(campaign)
    const pcLableWordingMaxLength = createType?.key === "fnb" ? 10 : 20;
    let validate = {
      required: {},
      isEmptyCampaignSchedules: {
        schedules: formatValidation(
          t("validation.statusCode.code.1"),
          t(`item.campaign.schedules`)
        )
      }
    };

    let validatePromotionCampaign = {
      required: {},
      maxLength: {
        pcDisplayName: formatValidation(t("validation.statusCode.code.4"), 50),
        pcDescription: formatValidation(t("validation.statusCode.code.4"), 200),
        pcLableWording: formatValidation(
          t("validation.statusCode.code.4"),
          pcLableWordingMaxLength
        ),
        pcCtaName: formatValidation(t("validation.statusCode.code.4"), 20)
      }
    };

    if (this.state.createType === CAMPAIGN_ENUM.CREATE_TYPE.DIEM) {
      validate.required = {
        name: formatValidation(
          t("validation.statusCode.code.1"),
          t(`item.campaign.name`)
        ),
        channelNull: formatValidation(
          t("validation.statusCode.code.1"),
          t(`item.campaign.channel`)
        ),
        discountType: formatValidation(
          t("validation.statusCode.code.1"),
          t(`item.campaign.discountPointType`)
        ),
        discountValue: formatValidation(
          t("validation.statusCode.code.1"),
          t(`item.campaign.discountPointValue`)
        ),
        productValues: formatValidation(
          t("validation.statusCode.code.1"),
          t(`item.campaign.productValues`)
        ),
      }
    } else {
      validatePromotionCampaign.required = {
        pcDisplayName: formatValidation(
          t("validation.statusCode.code.1"),
          t(
            `item.campaign.campaignPromotionInfoSection.vptPlaceholder.displayName`
          )
        ),
        pcDescription: formatValidation(
          t("validation.statusCode.code.1"),
          t(
            `item.campaign.campaignPromotionInfoSection.vptPlaceholder.description`
          )
        ),
        pcLableWording: formatValidation(
          t("validation.statusCode.code.1"),
          t(
            `item.campaign.campaignPromotionInfoSection.vptPlaceholder.lableWording`
          )
        ),
        pcCtaName: formatValidation(
          t("validation.statusCode.code.1"),
          t(`item.campaign.campaignPromotionInfoSection.vptPlaceholder.ctaName`)
        )
      }
      validate.required = {
        name: formatValidation(
          t("validation.statusCode.code.1"),
          t(`item.campaign.name`)
        ),
        codePrefix: formatValidation(
          t("validation.statusCode.code.1"),
          t(`item.campaign.codePrefix`)
        ),
        promotionType: formatValidation(
          t("validation.statusCode.code.1"),
          t(`item.campaign.promotionType`)
        ),
        channelNull: formatValidation(
          t("validation.statusCode.code.1"),
          t(`item.campaign.channel`)
        )
      }
    }
    
    let valueValidate = {};

    if (createType?.key !== "hotel") {
      validate = {
        ...validate,
        minLength: {
          productType: formatValidation(
            t("validation.statusCode.code.1"),
            t(`item.campaign.productType`)
          )
        }
      };
      valueValidate = {
        ...valueValidate,
        minLength: {
          productType: 1
        }
      };
    } else {
      validate = {
        ...validate,
        minLength: {}
      };
      valueValidate = {
        ...valueValidate,
        minLength: {}
      };
    }

    if (createType?.key === "fnb") {
      validate.minLength.propertyIds = formatValidation(
        t("validation.statusCode.code.1"),
        "Property"
      );
      validate.minLength.menuItemIds = formatValidation(
        t("validation.statusCode.code.1"),
        t(`item.campaign.skuIds`)
      );
      valueValidate.minLength.propertyIds = 1;
      valueValidate.minLength.menuItemIds = 1;
    }

    let valueValidatePromotionCampaign = {
      maxLength: {
        pcDisplayName: 50,
        pcDescription: 200,
        pcLableWording: pcLableWordingMaxLength,
        pcCtaName: 20
      }
    };

    if(campaign.channel.length !== 0) {
      delete validate.required.channelNull
    }

    if (campaign.codeType === CAMPAIGN_ENUM.CODE_TYPE.CUSTOMIZE.id) {
      delete validate.required[`codePrefix`];
      validate = {
        ...validate,
        required: {
          ...validate.required,
          maxCodeCount: formatValidation(
            t("validation.statusCode.code.1"),
            t(`item.campaign.maxCodeCount`)
          )
        }
      };
    } else {
      delete validate.required[`maxCodeCount`];
    }
    if (campaign.isLoyaltyVoucher) {
      validate = {
        ...validate,
        required: {
          ...validate.required
          // loyaltyBenefitCode: formatValidation(t('validation.statusCode.code.1'), t(`item.campaign.loyaltyBenefitCode`)),
          // loyaltyCampaignCode: formatValidation(t('validation.statusCode.code.1'), t(`item.campaign.loyaltyCampaignCode`)),
        }
      };
    }

    if (campaign.isPaymentCampaign) {
      const bankType = campaign.paymentCampaign.bankType || CAMPAIGN_ENUM.PAYMENT_BANK_TYPE.ONEPAY.id;
      if (bankType === CAMPAIGN_ENUM.PAYMENT_BANK_TYPE.ONEPAY.id) {
        validate.required.refCode = formatValidation(
          t("validation.statusCode.code.1"),
          t(`item.campaign.paymentCampaign.refCodeValidate`)
        );
      }
      validate.required.bankTitle = formatValidation(
        t("validation.statusCode.code.1"),
        t(`item.campaign.paymentCampaign.bankValidate`)
      );
      validate.required.bankDiscountType = formatValidation(
        t("validation.statusCode.code.1"),
        t(`item.campaign.paymentCampaign.bankDiscountType`)
      );
    }

    if (this.state.action === DETAIL_ACTIONS.CREATE) {
      validate.required.languageCode = formatValidation(
        t("validation.statusCode.code.1"),
        t(`translate.defaultLanguage`)
      );
    }

    let result = multipleValidate(
      {
        ...campaign,
        refCode: campaign.paymentCampaign
          ? campaign.paymentCampaign.refCode
          : null,
        bankTitle: campaign.paymentCampaign
          ? campaign.paymentCampaign.bankTitle
          : null,
        bankDiscountType: campaign.paymentCampaign
          ? campaign.paymentCampaign.bankDiscountType
          : null,
        ...promotionCampaign
      },
      validate,
      valueValidate
    );
    result = {
      ...result,
      ...this.validatePaymentCampaign(campaign)
    };
    // if (campaign.objectType !== CAMPAIGN_ENUM.OBJECT_TYPE.ALL.id
    //     && ((campaign.objectType === CAMPAIGN_ENUM.OBJECT_TYPE.SPECIFIC.id && campaign.emails.length <= 0) || (campaign.objectType === CAMPAIGN_ENUM.OBJECT_TYPE.MEMBER.id && campaign.memberShipTypes.length <= 0))) {
    //     const resultObjectType = {
    //         objectType: {
    //             classError: "hms-error-form",
    //             messageError: capitalizeFirstLetter(t('validation.statusCode.code.1').replace('%s', t(`item.campaign.useObjectHeader`)).toLowerCase())
    //         }
    //     }
    //     result = {
    //         ...result,
    //         ...resultObjectType,
    //     }
    // }
    if (this.state.createType === CAMPAIGN_ENUM.CREATE_TYPE.MARKUP) {
      if (
        !campaign.promotionMarkup.markupCampaigns ||
        campaign.promotionMarkup.markupCampaigns.length === 0
      ) {
        result.promotionMarkup = formatValidation(
          t("validation.statusCode.code.1"),
          t(`item.campaign.titleConfigPromotionMarkup`)
        );
      }
    }
    if (
      campaign.objectType === CAMPAIGN_ENUM.OBJECT_TYPE.MEMBER.id ||
      campaign.objectType === CAMPAIGN_ENUM.OBJECT_TYPE.ANOTHER.id
    ) {
      const userLimitFields = [
        {
          field: "userFrequencyLimitCount",
          label: t("item.campaign.userFrequencyLimitCount")
        }
      ];
      if (campaign.getUserFrequencyLimitCount() && !campaign.userFrequencyLimitPeriod) {
        result.userFrequencyLimitPeriod = {
          classError: "hms-error-form",
          messageError: t("item.campaign.userFrequencyLimitPeriodRequired")
        };
      }
      if (this.state.createType === CAMPAIGN_ENUM.CREATE_TYPE.HOTEL) {
        userLimitFields.push({
          field: "maxRoomNightPerUser",
          label: t("item.campaign.maxRoomNightPerUser")
        });
      }
      userLimitFields.forEach(({ field, label }) => {
        if (!isPositiveIntegerOrEmpty(campaign[field])) {
          result[field] = {
            classError: "hms-error-form",
            messageError: formatValidation(
              t("item.campaign.positiveIntegerInvalid"),
              label,
              true
            )
          };
        }
      });
    }
    if (!isLoyaltyPromotion) {
      let resultPromotionCampaign = multipleValidate(
        {
          ...campaign,
          ...promotionCampaign
        },
        validatePromotionCampaign,
        valueValidatePromotionCampaign
      );
      result = { ...result, ...resultPromotionCampaign };
    }
    this.setState({ validation: result });
    return Object.keys(result).length < 1;
  }

  isDisableSubmit = () => {
    const { action } = this.state;
    return (
      (action === DETAIL_ACTIONS.CREATE && !permissionActions.allowCreate) ||
      (action === DETAIL_ACTIONS.UPDATE && !permissionActions.allowUpdate)
    );
  };
}

export default withTranslation()(CampaignDetail);
